import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_Competition_PageMenu_ApiEnum } from './CompetitionDetailConfigApiInterface';

export enum Config_CompetitionStatPlayers_ActionsMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_CompetitionStatPlayers_Modules_ApiEnum {
    'indications' = 'indications',
    'overview' = 'overview',
    'stats_for_players' = 'stats_for_players',
    'warning' = 'warning',
}

export enum Config_CompetitionStatPlayers_ActionsOther_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_CompetitionStatPlayers_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_CompetitionStatPlayers_ApiInterface
    extends ConfigDataInterface<
        Config_CompetitionStatPlayers_Modules_ApiEnum,
        Config_CompetitionStatPlayers_ActionsMenu_ApiEnum,
        Config_CompetitionStatPlayers_ActionsOther_ApiEnum,
        Config_Competition_PageMenu_ApiEnum,
        Config_CompetitionStatPlayers_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
